<template>
  <dataCard title="Porcentaje Sentimientos" fact="Positivo, neutro y negativo" icon="fal fa-percent" :action="false" @borrar_widget="borrar_widget('PorcentajesSentimientos'); $emit('widget_eliminado','PorcentajesSentimientos')">
    <template v-slot:barra>
      <v-sheet height="10" width="100%" class="d-flex flex-row mb-2" rounded>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-sheet
              v-bind="attrs"
              v-on="on"
              height="10" class="d-flex justify-center align-center" :width="porcentajes_sentimientos['positives']+'%'" color="success" style="border-radius: 5px 0 0 5px;">
            </v-sheet>
          </template>
          <span>{{porcentajes_sentimientos['positives'].split(".")[0]=="0" ? '' : porcentajes_sentimientos['positives'].split(".")[0]+'%'}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-sheet
              v-bind="attrs"
              v-on="on"
              height="10" class="d-flex justify-center align-center" :width="porcentajes_sentimientos['neutres']+'%'" color="warning">
              </v-sheet>
          </template>
          <span>{{porcentajes_sentimientos['neutres'].split(".")[0]=="0" ? '' : porcentajes_sentimientos['neutres'].split(".")[0]+'%'}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-sheet
              v-bind="attrs"
              v-on="on"
              height="10" class="d-flex justify-center align-center" :width="porcentajes_sentimientos['negatives']+'%'" color="error" style="border-radius: 0 5px 5px 0;">
              </v-sheet>
          </template>
          <span>{{porcentajes_sentimientos['negatives'].split(".")[0]=="0" ? '' : porcentajes_sentimientos['negatives'].split(".")[0]+'%'}}</span>
        </v-tooltip>

      </v-sheet>
    </template>
  </dataCard>
</template>

<script>
import DataCard from "@/components/cards/DataCard.vue";
import apiExtract from "@/api/modules/extract";
import { mapActions } from 'vuex';
export default {
  data(){
    return {
      totales_elementos:{
        negatives:1,
        neutres:1,
        positives:1,
      }
    };
  },
  components:{
    DataCard
  },
  methods:{
    getData(){
      apiExtract.getAllElementsCounts(this.$route.query.process_id)
      .then((resp)=>{
          if(resp){
            this.totales_elementos = resp.data.total_elements;
          }
      })
    },
    ...mapActions({
      borrar_widget: 'auth/removeWidget'
    })
  },
  computed:{
    porcentajes_sentimientos(){
      var r={}
      let sum = 0;
      if (this.totales_elementos!=null) {
        Object.keys(this.totales_elementos).forEach((k) => {
          sum += this.totales_elementos[k]
        });
        Object.keys(this.totales_elementos).forEach((k) => {
          r[k]=(this.totales_elementos[k]*100/sum).toString().slice(0,5)
        });
      }
      return r;
    },
  },
}
</script>

<style >
</style>
